module.exports = __webpack_public_path__ + "static/media/Weatherjokes.53adc3a9.jpg";